import { formatKpiValue } from '../utils/formatters';

export default function StatCard({ item }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{item.label}</div>
      <div className="stat-value">{formatKpiValue(item)}</div>
      {item.helper && <div className="stat-helper">{item.helper}</div>}
    </div>
  );
}
